<template>
    <div class="container order-page">
        <div class="header render-box f-s-b" v-touch:tap="goToAddressPage">
            <van-image 
                class="icon-image"
                lazy-load
                fit="cover"
                :src="imageList[0]"
            />
            <div class="user-info f-s-b">
                <div class="info-top">
                    <span class="name ellipsis">{{userInfo.name || '暂无收货人信息'}}</span>
                    <span class="phone">{{userInfo.phone}}</span>
                </div>
                <div class="info-below f-s-b">
                    <span class="address ellipsis">{{userInfo.address || '添加收货地址'}}</span>
                    <i class="iconfont iconjiantouarrow487"></i>
                </div>
            </div>
        </div>

        <ul class="body render-box">

            <li 
                v-for="(item, index) in productInfo.list" :key="index"
                class="body-item f-s-b"
            >

                <van-image 
                    class="body-item-image"
                    lazy-load
                    :src="item.image"
                />

                <ul class="product-info f-s-b">
                    <li class="name ellipsis2">{{item.name}}</li>
                    <li class="name sku ellipsis">规格:  {{item.sku}}</li>
                    <li class="price ellipsis2 f-s-b">
                        <div class="left-price g-b-500">
                            <span class="rmb">¥</span>
                            <span class="number">{{item.price}}</span>
                        </div>
                        <van-stepper
                            integer
                            disabled-input
                            :value="item.number"
                            async-change
                            :min="item.min"
                            :max="item.max"
                            @plus="onChange(item,'plus')"
                            @minus="onChange(item,'minus')"
                        />
                    </li>
                </ul>

            </li>

            <li class="product-info-row f-s-b you-hui">
                <div class="left-font">优惠</div>
                <div class="price">
                    <span>¥</span>
                    <span>{{productInfo.discount}}</span>
                </div>
            </li>
            <li class="product-info-row f-s-b" v-touch:tap.prevent="onChangeShow">
                <div class="left-font">配送方式</div>
                <div class="f-c">
                    <span>{{columns[columnsActive]}}</span>
                    <i class="iconfont iconjiantouarrow487 icon-size"></i>
                </div>
            </li>
            <li class="product-info-row f-s-b marker-box">
                <div class="left-font">订单备注</div>
                <van-field
                    class="textarea-box"
                    v-model="productInfo.remarks"
                    :clearable="true"
                    rows="1"
                    autosize
                    type="textarea"
                    placeholder="选填,请先和官方确认一致"
                />
            </li>
            <li class="product-info-row f-s-b total">
                <div >
                    <span class="total-number">共{{productInfo.list.length}}计</span>
                    <span class="txt">小计:</span>
                    <span class="price">¥</span>
                    <span class="price g-b-500">{{getTotalPrice}}</span>
                </div>
            </li>

        </ul>

        <div class="render-box pay-box f-s-b">
            <div class="pay-left f-s-b">
                <van-image 
                    class="pay-image"
                    lazy-load
                    :src="imageList[1]"
                />
                <span class="txt">支付方式</span>
            </div>
            <div class="pay-right f-s-b">
                <van-image 
                    class="pay-image wei-xin"
                    lazy-load
                    :src="imageList[2]"
                />
                <span class="txt">微信支付</span>
                <i class="iconfont iconjiantouarrow487 icon-size"></i>
            </div>
        </div>

        <div class="foot f-s-b">
            <div class="foot-left f-c ellipsis g-b-500">
                <span class="f-c">合计:</span>
                <span class="rmb">¥</span>
                <span class="number ">{{getTotalPrice}}</span>
            </div>
            <div class="foot-right f-s-b g-b-500">
                <!-- <div class="f-c first-buy" v-touch:tap="routerPage('orderSuccess')">提交订单</div> -->
                <div class="f-c first-buy" v-touch:tap="createOrder">提交订单</div>
            </div>
        </div>

        <van-popup
            v-model="show"
            round
            closeable
            position="bottom"
            :style="{ height: '30%' }"
        >
            <van-picker :columns="columns" @change="onChangeDistributionMode"  />
        </van-popup>

    </div>
</template>

<script>
    import { 
        Stepper,
        Field, 
        Picker,
        Popup,
    } from 'vant';
    import {
        getUserAddrListUrl,
        createOrderUrl,
        wxWapUrl,
    } from '@js/shoppingUrl.js';
    import util from '@util';
    import http from '@js/http-hbt.js';
    export default {
        data() {
            return {
                show: false,
                columnsActive: 0,
                columns: [ '快递配送(包邮)','自提'],
                imageList: [
                    require('@image/shopping/344.png'),
                    require('@image/shopping/33.png'),
                    require('@image/shopping/3322.png'),
                ],
                userInfo: {
                    name: '',
                    phone: '',
                    address: '',
                    // name: '王丽丽',
                    // phone: '16677889999',
                    // address: '光华村街道2578号光华村街道2578号',
                },
                productInfo: {
                    list:[
                        {
                            image:require('@image/home/wanglili.png'),
                            name: '2020年 满汉全席日历 日历菜谱与传统文化相结合碗碟',
                            sku: '圆形5CM*5CM',
                            price: '45',
                            min: 1,
                            max: 3,
                            number: 1,
                        },
                        {
                            image:require('@image/home/wanglili.png'),
                            name: '2020年 满汉全席日历 日历菜谱与传统文化相结合碗碟',
                            sku: '圆形5CM*5CM',
                            price: '45',
                            max: 3,
                            max: 3,
                            number: 1,
                        },
                    ],
                    //  优惠
                    discount: 3,
                    remarks: '',
                    orderPrice: '345.00'
                },
                requestParams:{
                    offset: 0,
                    psize: 1,
                },
                //  1:详情进入 2: 购物车进入
                typeNumber: 1,
            }
        },
        created() {
            var {
                typeNumber = 1
            } = this.$route.query;
            this.typeNumber = typeNumber;
            this.init();
        },
        mounted() {
            var inputS = document.getElementsByTagName('input');
            for (let index = 0, len = inputS.length; index < len; index++) {
                const element = inputS[index];
                element.readOnly = true;
            }
        },
        methods: {
            init(){

                //  是获取默认联系人还是去联系人列表切换了收货人地址
                var tempDefaultContacts = JSON.parse( sessionStorage.getItem('temp-set-shop-car-contacts'));
                if(tempDefaultContacts === null){
                    this.getUserAddrList();
                }else{
                    this.userInfo = tempDefaultContacts;
                    sessionStorage.removeItem('temp-set-shop-car-contacts');
                }

                this.productInfo.list = [];
                this.productInfo.orderPrice = 0;
                this.productInfo.discount = 0;
                
                var map = this.$store.getters.getShopCar;
                if(this.typeNumber === 1){
                    map.forEach(item=>{
                        this.productInfo.list.push({
                            image: item.productInfo.imageList.length > 0 ? item.productInfo.imageList[0] : "",
                            name: item.productInfo.name,
                            sku: item.rawData.SKU_NAME,
                            price: item.rawData.REAL_PRICE,
                            min: 1,
                            max: item.rawData.NUMBER,
                            number: item.number,
                            rawData: item,
                        })
                    })
                }else{
                    map.forEach(item=>{
                        this.productInfo.list.push({
                            image: item.rawData.image,
                            name: item.rawData.name,
                            sku: item.rawData.sku,
                            price: item.rawData.price,
                            min: 1,
                            max: item.rawData.rawData.stockNum,
                            number: item.rawData.commitData.cartNum,
                            rawData: item,
                        })
                    })
                }
                // console.log(
                //     this.productInfo.list
                // )
            },
            onChangeDistributionMode(picker, value, index) {
                this.columnsActive = index;
                this.onChangeShow();
            },
            onChangeShow(){
                this.show = !this.show;
            },
            getUserAddrList(){
                http.post(getUserAddrListUrl,{
                    userId: this.getUserId,
                    offset: this.requestParams.offset,
                    psize: this.requestParams.psize,
                }).then(res=>{
                    var {
                        data: array
                    } = res;
                    if(array.length === 1){
                        var [ info ] = array; 
                        this.userInfo.name = info.contact;
                        this.userInfo.phone = info.telno;
                        this.userInfo.address = info.detailaddress;
                    }
                })
            },
            createOrder() {
                if(this.userInfo.name === '' || this.userInfo.phone === '' || this.userInfo.address === '') {
                    // this.$toast('收货人信息不完整')
                    this.$dialog.alert({
                        title: '提示',
                        message: '收货人信息不完整,请确认核实收货人地址信息无误'
                    }).then(() => {
                    // on close
                    });
                    Dialog({ message: '提示' });
                    return;
                }
                var skus = {},
                    consumeInfo = {
                        // 1上门消费，2送货上门
                        mode: this.columnsActive === 0 ? 2 : 1,
                        consumeTime: util.formatTime(new Date()),
                        phone: this.userInfo.phone,
                        contact: this.userInfo.name,
                        address: this.userInfo.address
                    };
                this.productInfo.list.map(item=>{
                    skus[item.rawData.skuId] = item.number
                })
                var param = {
                    channel: "ec",
                    userId: this.getUserId,
                    // userId: '53bf16892cfa4a2295b7f7c229f3493e',
                    site: 2,
                    phoneNum: this.userInfo.phone,
                    shortMsgCode: '999999',
                    skus: JSON.stringify(skus),
                    consumeInfo: JSON.stringify(consumeInfo),
                    remark: this.productInfo.remarks,
                    scannerUse: false,//  是否是到店的扫码使用
                    tableNumber: '',//..桌号ID
                };
                this.$toast('下单');
                // console.log(param)
                // http.post(createOrderUrl, param)
                //     .then(res=>{
                //         var {
                //             data: {
                //                 orderId
                //             }
                //         } = res;
                //         if(orderId){
                //             http.post(wxWapUrl, { orderId })
                //                 .then(res=>{
                //                     var {
                //                         data
                //                     } = res;
                //                     if(data){
                //                         window.location.href = data;
                //                     }
                //                 })
                //         }else{
                //             this.$toast('创建订单失败');
                //         }
                //     })
            },
            // routerPage(name){
            //     return ()=> this.$router.push({ name })
            // },
            goToAddressPage(name){
                this.$router.push({ name: 'address', query: { type: 'changeContacts' } })
            },
            onChange(item,type) {
                this.$toast.loading({
                    // overlay: true,
                    forbidClick: true 
                });
                setTimeout(() => {
                    if(type === 'plus'){
                        item.number++
                    }else{
                        item.number--
                    }
                    this.$toast.clear();
                }, 500);
            }
        },      
        computed: {
            getTotalPrice(){
                var price = 0;
                this.productInfo.list.map(item=>{
                    price += ( Number(item.number) * Number(item.price) )
                })
                this.productInfo.orderPrice = price;
                return price;
            },
            getUserId(){
                return this.$store.state.userInfo.userId || ''
            },
        },
        components: {
            [Stepper.name]: Stepper,
            [Field.name]: Field,
            [Picker.name]: Picker,
            [Popup.name]: Popup,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .container{
        height: ~"calc(100% - 60px)" !important;
        position: relative;
        padding: 7px;
        .render-box{
            background:rgba(255,255,255,1);
            box-shadow:0px 1px 8px 0px rgba(212,206,218,0.5);
            border-radius:5px;
            margin-bottom: 12px;
            padding: 13px 14px;
        }
        .icon-image{
            width:33px;
            height:33px;
            // border-radius: 100%;
            // overflow: hidden;
        }
        .header{
            .user-info{
                box-sizing: border-box;
                padding-left: 10px;
                width: ~"calc(100% - 33px)";
                justify-content: flex-start;
                flex-direction: column;
                font-size: 13px;
                color: #A6A6A6;
                div{
                    width: 100%;
                }
                .info-top{
                    font-size: 14px;
                    .name{
                        color: #343434;
                        max-width: 50%;
                        display: inline-block;
                        vertical-align: middle;
                    }
                    .phone{
                        font-size: 12px;
                        margin-left: 10px;
                        display: inline-block;
                        vertical-align: middle;
                    }
                    margin-bottom: 13px;
                }
                .info-below{
                    .address{

                    }
                }
            }
        }
        .body{
            font-size: 12px;
            .body-item{
                @imgeSize:86px;
                border-bottom: .5px solid #EAEAEA;
                padding-bottom: 18px;
                margin-bottom: 18px;
                box-sizing: border-box;
                // height: @imgeSize;
                .body-item-image{
                    width: @imgeSize;
                    height: @imgeSize;
                    border-radius:4px;
                    overflow: hidden;
                }
                .product-info{
                    color: #35373C;
                    flex-direction: column;
                    align-items: flex-start;
                    box-sizing: border-box;
                    height: auto;
                    width: calc(~"100% - @{imgeSize}");
                    padding-left: 15px;
                    .price{
                        width: 100%;
                        .left-price{
                            color: #FF7613;
                            .number{
                                font-size: 18px;
                            }
                        }
                    }
                    .sku{
                        margin: 8px 0;
                    }
                }
            }
            .product-info-row{
                // overflow: hidden;
                height: auto;
                box-sizing: border-box;
                font-size: 12px;
                color: #595959;
                .price{
                    color: #FF9142;
                }
                .left-font{
                    width: 90px;
                }
            }
            .marker-box{
                // mar
                margin-top: 10px;
            }
            .you-hui{
                margin-bottom: 10px;
            }
            .total{
                justify-content: flex-end;
                .price{
                    font-size: 18px;
                }
                .total-number{
                    color: #B4B4B4;
                    font-weight: 400;
                }
                .txt{
                    margin: 0 10px;
                    color: #35373C;
                }
            }
        }
        .pay-box{
            font-size: 13px;
            color: #2B2B2B;
            .pay-image{
                width: 24px;
                height: 24px;
            }
            .wei-xin{
                height: auto;
            }
            .pay-right{
                color: #6C6C6C;
            }
            .txt{
                margin: 0 10px;
            }
        }
        .foot{
            height: 40px;
            overflow: hidden;
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            background:rgba(255,255,255,1);
            border-top-left-radius:5px;
            border-top-right-radius:5px;
            padding: 10px 12px;
            .foot-left{
                width: ~'calc(100% - 100px)';
                justify-content: flex-start;
                color: #686868;
                line-height: 18px;
                .icon-size{
                    color: #9C9C9C;
                }
                font-size: 12px;
                .rmb{
                    margin-left: 5px;
                    height: 100%;
                    color: #FF9142;
                    display: inline-block;
                    transform: translateY(1px);
                }
                .number{
                    color: #FF9142;
                    font-size: 18px;
                }
            }
            .foot-right{
                width:96px;
                background:linear-gradient(162deg,rgba(255,163,0,1) 0%,rgba(255,126,154,1) 100%);
                border-radius:1000px;
                font-size: 13px;
                height:40px;
                box-sizing: border-box;
                overflow: hidden;
                color: #ffffff;
                .add-shopping-car{
                    box-sizing: border-box;
                    width: 110px;
                    height:100%;
                    background:linear-gradient(146deg,rgba(255,200,2,1) 0%,rgba(254,151,1,1) 100%);
                }
                .first-buy{
                    box-sizing: border-box;
                    width: 110px;
                    height:100%;
                }
            }
        }
    }
</style>